"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LANG_PL_TRANS = {
    'time picker': 'Wybór czasu',
    'today': 'Dziś',
    'set time': 'Ustaw czas',
    'close': 'Zamknij',
    'cancel': 'Anulować',
    'confirm': 'Potwierdź',
    'hour': 'Godzina',
    'minute': 'Minuta',
    'second': 'Sekunda',
};
//# sourceMappingURL=pl.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/ng-pick-datetime/locale/pl.js
// module id = ../../../../ng-pick-datetime/locale/pl.js
// module chunks = 18